import { render, staticRenderFns } from "./CustomVueTagsInput.vue?vue&type=template&id=0d1f507d&"
import script from "./CustomVueTagsInput.vue?vue&type=script&lang=js&"
export * from "./CustomVueTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomVueTagsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports